module.exports = __webpack_public_path__ + "img/average_target_fisik_format.270a4cef.png";